import { createAction, Dispatch } from '@reduxjs/toolkit';
import ServerApi from '../../api/serverApi';
import { ServerModel } from '../../models/serverModel';
import { AppError } from '../../types/appError';

export const setSelectedServerName = createAction<string>('servers/setSelectedServerName');

export const serversFetchAllRequestAction = createAction<void>('servers/fetchAllRequest');
export const serversFetchAllSuccessAction = createAction<ServerModel[]>('servers/fetchAllSuccess');
export const serversFetchAllFailureAction = createAction<AppError>('servers/fetchAllFailure');

export const fetchAllServers = () => async (dispatch: Dispatch) => {
  dispatch(serversFetchAllRequestAction());
  try {
    const allServers = await ServerApi.fetchAll();
    dispatch(serversFetchAllSuccessAction(allServers))
  } catch (error) {
    dispatch(serversFetchAllFailureAction(error as AppError));
  }
}

export const serversFetchOneRequestAction = createAction<void>('servers/fetchOneRequest');
export const serversFetchOneSuccessAction = createAction<ServerModel>('servers/fetchOneSuccess');
export const serversFetchOneFailureAction = createAction<AppError>('servers/fetchOneFailure');

export const fetchServerById = (serverName: string) => async (dispatch: Dispatch) => {
  dispatch(serversFetchOneRequestAction);
  try {
    const oneServer = await ServerApi.fetchServerById(serverName);
    dispatch(serversFetchOneSuccessAction(oneServer));
  } catch (error) {
    dispatch(serversFetchOneFailureAction(error as AppError));
  }
}
